import instance from "utils/axios";
import config from "utils/config";
import notification from "../utils/notification";
import errorHandler from "utils/error";
class Auth {
    static async signIn(email, password, admin) {
        try {
            const response = await instance
                .post(config.AUTH_PATH + "/sign-in", {
                    email,
                    password,
                    admin
                });
            const { data } = response;
            notification('successful login', data.message, 'success');
            localStorage.setItem("token", JSON.stringify(data.token));
            // localStorage.setItem("user", JSON.stringify(data.user));
            // localStorage.setItem("role", JSON.stringify(data.user.role));
            return true;
        }
        catch (err) {
            return errorHandler(err)
        }

    }

    static async signUp(email, password, country, teams, name) {
        try {
            const response = await instance
                .post(config.AUTH_PATH + "/sign-up", {
                    email,
                    password,
                    name
                });
            const { data } = response;
            notification('successful signup', data.message, 'success');

            return true;
        }
        catch (err) {
            if (err.response) {
                const { data } = err.response;
                if (data)
                    notification('error', data.message, 'warning');
            }

            else
                notification('error', err.message, 'danger');
            return false;

        }

    }
    static isLogin() {
        if (localStorage.getItem('token')) {
            return true;
        }

        return false;
    }
    static signOut() {
        localStorage.removeItem("token");
        notification('successful logout', "successfull logout from server");
    }

}


export default Auth;